import { render, staticRenderFns } from "./PublishPopover.vue?vue&type=template&id=1571360e&scoped=true"
import script from "./PublishPopover.vue?vue&type=script&lang=js"
export * from "./PublishPopover.vue?vue&type=script&lang=js"
import style0 from "./PublishPopover.vue?vue&type=style&index=0&id=1571360e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1571360e",
  null
  
)

export default component.exports